<div class="dashboard-layout flex flex-col h-[100dvh] overflow-hidden bg-slate-50 md:flex-row"
     [class.collapsed-sidebar]="isSidebarCollapsed()"
     [class.has-bottom-nav]="showBottomNav()">
  <!-- Mobile Sidebar Overlay Backdrop -->
  @if (sidebarOpen()) {
    <div
      class="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 md:hidden"
      (click)="closeSidebar()"
    ></div>
  }

  <!-- Sidebar -->
  <app-sidebar [isOpen]="sidebarOpen()" [isCollapsed]="isSidebarCollapsed()" (closeSidebar)="closeSidebar()" />

  <!-- Main Content Column -->
  <div class="main-content flex-1 flex flex-col min-h-0">
    <!-- Header — visible on all screen sizes; CSS controls mobile layout -->
    <div class="flex-shrink-0">
      <app-header (toggleSidebar)="toggleSidebar()" />
    </div>

    <!-- Scrollable Content -->
    <main class="flex-1 min-h-0 overflow-y-auto custom-scroll">
      <router-outlet />
    </main>
  </div>

  <!-- Mobile Bottom Navigation -->
  @if (showBottomNav()) {
    <app-bottom-nav />
  }
</div>
